import { AppSelectBox } from 'components';
import useUsersList from 'hooks/API/GET/useUsersList';
import { Fragment } from 'react';

function UsersDropDown({ enableAPI, value, handleChange, fieldErrors = {} }) {
  const queryParams = `?mode=dropdown`;
  const { data, isLoading, isError } = useUsersList({ enabled: enableAPI, queryParams });

  return (
    <AppSelectBox
      labelProps={{ label: 'Select User' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

UsersDropDown.defaultProps = {
  handleChange: () => {},
};

export default UsersDropDown;
